import { Tabs } from "antd";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import {
  useGetAllMouldsByIdQuery,
  useGetSelectByIdApiQuery,
  useGetUserDetailByIdQuery,
} from "../../../services/api";

import AddNewLog from "../FinishedGoodsPreview/addNewLog";
import LoginHistory from "../FinishedGoodsPreview/loginHistory";
import WarehouseTab from "../FinishedGoodsPreview/warehouse";
import VendorTab from "../RawMaterialPreview/vendor";
import JobDetail from "./jobDetails";
import MouldPreviewDetail from "./productDetail";
// import JobHandDetailPreview from "./productDetails";
// import "./index.css";

interface ICreateSales {
  setId: (data: string) => void;
  setActive: (data: boolean) => void;
  setOpenDrawer: (data: boolean) => void;
}
export const MouldPreview: React.FC<ICreateSales> = ({
  setId,
  setActive,
  setOpenDrawer,
}) => {
  const [open, setOpen] = useState(false);
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const log = searchParams.get("log");

  const { data, isLoading } = useGetAllMouldsByIdQuery(Number(id), {
    skip: Number(id) === 0,
  });

  useEffect(() => {
    if (id) {
      setId(data?.data?.mould_id as string);
      setActive(data?.data?.is_active as boolean);
    }
  }, [id, data?.data?.mould_id]);
  const [activeTab, setActiveTab] = useState("1");

  const handleTabChange = (key: string) => {
    setActiveTab(key);
  };
  const { data: selectById } = useGetSelectByIdApiQuery("mould");

  const userId = localStorage.getItem("user_id");

  const { data: userDetail } = useGetUserDetailByIdQuery(userId);
  useEffect(() => {
    if (log) {
      setActiveTab("5");
    }
  }, [log]);
  return (
    <>
      <Tabs
        className="finishedGoodsTab"
        activeKey={activeTab}
        onChange={handleTabChange}
        type="card"
        items={
          localStorage?.getItem("user_role") === "2" ||
          localStorage?.getItem("user_role") === "1"
            ? [
                {
                  label: "Product Details",
                  key: "1",
                  children: (
                    <MouldPreviewDetail
                      setActive={setActive}
                      setId={setId}
                      data={data?.data as any}
                      isLoading={isLoading as boolean}
                      setOpenDrawer={setOpenDrawer}
                    />
                  ),
                },
                {
                  label: "Vendor Details",
                  key: "2",
                  children: <VendorTab data={data?.data?.job_card as any} />,
                },
                {
                  label: "Warehouse Details",
                  key: "3",
                  children: (
                    <WarehouseTab
                      data={data?.data as any}
                      sku={data?.data?.storage_unit as string}
                    />
                  ),
                },
              ]
            : [
                {
                  label: "Product Details",
                  key: "1",
                  children: (
                    <MouldPreviewDetail
                      setActive={setActive}
                      setId={setId}
                      data={data?.data as any}
                      isLoading={isLoading as boolean}
                      setOpenDrawer={setOpenDrawer}
                    />
                  ),
                },

                ...(data?.data?.job_card &&
                data?.data?.job_status &&
                data?.data?.job_card?.type !== "internal"
                  ? [
                      {
                        label: "Job Details",
                        key: "2",
                        children: (
                          <JobDetail
                            setActive={setActive}
                            setId={setId}
                            data={data?.data as any}
                            isLoading={isLoading as boolean}
                            setOpenDrawer={setOpenDrawer}
                          />
                        ),
                      },
                    ]
                  : []),

                ...(data?.data?.job_card &&
                data?.data?.job_card?.type !== "internal"
                  ? [
                      {
                        label: "Vendor Details",
                        key: "3",
                        children: (
                          <VendorTab data={data?.data?.job_card as any} />
                        ),
                      },
                    ]
                  : []),

                {
                  label: "Warehouse Details",
                  key: "4",
                  children: (
                    <WarehouseTab
                      data={data?.data as any}
                      sku={data?.data?.storage_unit as string}
                    />
                  ),
                },
                ...(data?.data?.is_active
                  ? [
                      {
                        label: "Log Inwards/Outwards",
                        key: "5",
                        children: open ? (
                          <AddNewLog
                            data={data?.data as any}
                            inventory_type="mould"
                            defaultCategoryId={selectById?.id as number}
                            setOpen={setOpen}
                            path="/moulds"
                          />
                        ) : (
                          <LoginHistory
                            modelId={Number(selectById?.id as number)}
                            objectId={Number(id)}
                            setOpen={setOpen}
                          />
                        ),
                      },
                    ]
                  : []), // Only include this tab if is_active is true
              ]
        }
      />
    </>
  );
};

export default MouldPreview;
